import { useQuery } from "@tanstack/react-query";
import { Users, BookOpen, DollarSign, ShoppingCart, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  if (isLoading) return <Loader2 className="h-8 w-8 animate-spin text-[#DCA846]" />;

  const cards = [
    { label: "Students", value: data.students, icon: Users },
    { label: "Courses", value: `${data.published}/${data.courses}`, icon: BookOpen, sub: "published" },
    { label: "Paid Orders", value: data.paid_orders, icon: ShoppingCart },
    { label: "Revenue", value: `$${Number(data.revenue).toFixed(2)}`, icon: DollarSign },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl font-bold uppercase tracking-tight">Dashboard</h1>
      <p className="mt-1 text-zinc-400">Overview of your academy.</p>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="rounded-lg border border-white/10 bg-zinc-900/50 p-6">
            <c.icon className="h-6 w-6 text-[#DCA846]" />
            <p className="mt-4 font-display text-3xl font-bold">{c.value}</p>
            <p className="text-sm text-zinc-400">{c.label} {c.sub && <span className="text-xs">({c.sub})</span>}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-10 font-display text-xl uppercase tracking-wide">Recent Orders</h2>
      <div className="mt-4 overflow-hidden rounded-lg border border-white/10">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900 text-left text-xs uppercase text-zinc-400">
            <tr><th className="p-3">Course</th><th className="p-3">Amount</th><th className="p-3">Status</th><th className="p-3">Date</th></tr>
          </thead>
          <tbody>
            {(data.recent_orders || []).length === 0 ? (
              <tr><td colSpan={4} className="p-6 text-center text-zinc-500">No orders yet.</td></tr>
            ) : data.recent_orders.map((o) => (
              <tr key={o.id} className="border-t border-white/5">
                <td className="p-3">{o.course_title}</td>
                <td className="p-3">${Number(o.amount).toFixed(2)}</td>
                <td className="p-3 capitalize">{o.payment_status}</td>
                <td className="p-3 text-zinc-500">{new Date(o.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
